import React from 'react';

import {useAlertCriteria} from 'src/modules/profile/user/tabs/content/alerts/hooks/useAlertCriteria';
import {SCOPE_KEY} from 'src/modules/profile/user/tabs/content/alerts/util';
import {uiToApiSort} from 'src/modules/profile/user/tabs/content/utils/util';
import {AlertSortField} from 'src/openapi/admin/models/AlertSortField';

import {SortHeaderWithDataTable} from '@pb/kit-component-sort-header';
import {Cell} from '@pb/kit-component-table';

export const AlertHeader = () => {
    const {criteria, setSort} = useAlertCriteria(SCOPE_KEY);

    return (
        <Cell width="600px" className="nowrap text-align_center">
            <SortHeaderWithDataTable
                caption="Alert"
                defaultDirection="ASC"
                direction={criteria?.alertSortField === AlertSortField.ALERT_NAME
                    ? criteria.sortDirection
                    : undefined}
                onSort={dir => setSort(AlertSortField.ALERT_NAME, uiToApiSort(dir))}
            />
        </Cell>
    );
};
